import type { PrReviewStatus, PrReviewTrigger, PrReviewVerdict } from './types';

/** `owner/repo` shape — guards the GitHub URL built from `repoFullName`. */
export const REPO_FULL_NAME_RE = /^[\w.-]{1,100}\/[\w.-]{1,100}$/;

/**
 * No "inconclusive" verdict exists on this feature — a failed run leaves
 * `verdict: null`. Callers must render that case separately, never as a
 * third pill alongside these two.
 */
export const VERDICT_META: Record<
  PrReviewVerdict,
  { label: string; variant: 'success' | 'destructive' }
> = {
  approve: { label: 'Approved', variant: 'success' },
  request_changes: { label: 'Changes requested', variant: 'destructive' },
};

export const STATUS_META: Record<
  PrReviewStatus,
  { label: string; variant: 'secondary' | 'success' | 'destructive' }
> = {
  queued: { label: 'Queued', variant: 'secondary' },
  running: { label: 'Running', variant: 'secondary' },
  completed: { label: 'Completed', variant: 'success' },
  failed: { label: 'Failed', variant: 'destructive' },
  // Transient handoff from the cheap first-pass reviewer to a stronger model;
  // a full review is still coming. Never carries a verdict.
  escalated: { label: 'Escalated', variant: 'secondary' },
};

export const TRIGGER_LABEL: Record<PrReviewTrigger, string> = {
  pull_request: 'Publish',
  mention: 'Mention',
  follow_up: 'Follow-up',
};
